import React, { useState, useEffect, useRef } from 'react';
import {
	Container,
	Button,
	Row,
	Col,
	Form,
	InputGroup,
	FormControl,
} from 'react-bootstrap';
import InputMask from 'react-input-mask';
import '../../assets/css/Cogen.css';
import prof from '../../assets/images/prof.svg';
import tw from '../../assets/images/tw.png';
import fb from '../../assets/images/fb.png';
import ProfileImage from '../../assets/images/profile.jpg';
import { MdOutlineFileUpload } from 'react-icons/md';
import linkedin from '../../assets/images/in.png';
import { useNavigate } from 'react-router-dom';
import { ReqGet, ReqPost } from '../../config/Requests';
import { Multiselect } from 'multiselect-react-dropdown';
import Select from 'react-select';
import _, { findIndex } from 'lodash';
import {
	formattedTags,
	formattedTitles,
	formattedOldTags,
} from '../../helper/utils';
import ParentTagsScreen from './client/ParentTags';
import ChildTagsScreen from './client/ChildTags';
import NewChildTag from './client/NewChildTag';
import { toast } from 'react-toastify';
import { Stack } from '@mui/material';

function ProfileUpdate({ _handleEdit }) {
	let navigate = useNavigate();
	const profileImage = useRef(null);
	const [profile, setProfile] = useState({});
	const userType = profile?.user_type;
	const nameRef = useRef();
	const emailRef = useRef();
	const lastNameRef = useRef();
	const groupStyles = {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	};

	const groupBadgeStyles = {
		backgroundColor: '#EBECF0',
		borderRadius: '2em',
		color: '#172B4D',
		display: 'inline-block',
		fontSize: 12,
		fontWeight: 'normal',
		lineHeight: '1',
		minWidth: 1,
		padding: '0.16666666666667em 0.5em',
		textAlign: 'center',
	};

	const [references, setReferences] = useState([
		{ first_name: '', last_name: '', email: '', type_of_reference: '' },
	]);
	const [req, setReq] = useState(false);
	const [titles, setTitles] = useState([]);
	const [tags, setTags] = useState([]);
	const [tagsSend, setTagsSend] = useState([]);
	const [imagePreview, setImagePreview] = useState(prof);
	const [statesData, setStatesData] = useState([]);
	const [citiesData, setCitiesData] = useState([]);
	const [chosenTags, setChosenTags] = useState([]);
	const [dataTitles, setDataTitles] = useState([]);
	// const [returnedTags, setReturnedTags] = useState([]);
	const [selectedTags, setSelectedTags] = useState([]);
	// const [parentTag, setParentTag] = useState(null);

	const [childTags, setChildTags] = useState([]);
	const [childTags2nd, setChildTags2nd] = useState([]);
	const [tools, setTools] = useState(['']);
	const [otherRequirements, setOtherRequirements] = useState(['']);
	const [expertise, setExpertise] = useState(['']);
	const [experiences, setExperiences] = useState([
		{ start_date: '', end_date: '', company: '', description: '' },
	]);
	const [jobType, setJobType] = useState(profile?.job_type);
	const [workerType, setWorkerType] = useState(profile?.worker_type);
	const [travelType, setTravelType] = useState(profile?.travel_type);
	const [meetingRequired, setMeetingRequired] = useState(
		profile?.meeting_required
	);
	const [selectedParent, setSelectredParent] = useState([]);
	const [selectedParent2, setSelectredParent2] = useState([]);
	const [selectedChild2, setSelectedChild2] = useState([]);
	const [selectedChild3, setSelectedChild3] = useState([]);
	const [childTags2, setChildTags2] = useState([]);
	const [childTags3, setChildTags3] = useState([]);
	const [checked1, setChecked1] = useState([]);
	const [childChecked, setChildChecked] = useState([]);
	const [childChecked2nd, setChildChecked2nd] = useState([]);
	const [childChecked2, setChildChecked2] = useState([]);
	const [childChecked3, setChildChecked3] = useState([]);
	const [checked2, setChecked2] = useState([]);
	const [parent, setParent] = useState('');
	const [parentShow, setParentShow] = useState(false);
	const [childrenShow, setChildrenShow] = useState(false);
	const [selectedChild, setSelectedChild] = useState([]);
	const [selectedChild2nd, setSelectedChild2nd] = useState([]);
	const [childSelected, setChildSelected] = useState([]);
	const [activeList, setActiveList] = useState([]);

	const [allValues, setAllValues] = useState({});
	const [image, setImage] = useState(prof);
	const [imageProgress, setImageProgress] = useState(false);

	if (imagePreview == undefined || !imagePreview) {
		setImagePreview(ProfileImage);
	}

	useEffect(() => {
		ReqGet('pro-titles')
			.then(res => {
				setTitles(res.data.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		ReqGet('tags')
			.then(res => {
				setTags(res.data.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		ReqGet('profile')
			.then(res => {
				setProfile(res.data);
				setReq(true);
			})
			.catch(err => {
				console.log(err.message);
			});
	}, []);

	useEffect(() => {
		if (titles.length === 0 && tags.length === 0) {
			return;
		}

		const dataTitles = formattedTitles(titles);
		// const returnedTags = formattedOldTags(tags);

		setDataTitles(dataTitles);
		// setReturnedTags(returnedTags)

		// setSelectedTags(formatSelectedTags(profile?.tags))
		// setChosenTags(profile?.tags?.map(tag => tag.id))

		// let tag = tags.find(tag => tag.id === profile.tag_parent_id)
		// setShowChildTag(true)
		// setParentTag({ label: tag?.display_name, value: tag?.id })
	}, [titles, tags, profile]);

	useEffect(() => {
		setAllValues({
			first_name: profile.first_name,
			middle_name: profile.middle_name,
			last_name: profile.last_name,
			company_name: profile.company_name,
			year_experience: profile.year_experience,
			// division_name: profile.division_name,
			email: profile.email,
			email2: profile.email2,
			phone: profile.phone,
			phone2: profile.phone2,
			start_date: profile.start_date,
			end_date: profile.end_date,
			professional_title_id: profile.professional_title_id,
			professional_title_name: profile?.professional_title?.name,
			address: profile.address,
			city: profile.city?.id,
			state: profile.state?.id,
			zip: profile?.zip,
			// official_doc: profile.official_doc,
			supporting_file: profile.supporting_file,
			linkedin_link: profile.linkedin_link,
			twit_link: profile.twit_link,
			facebook_link: profile.facebook_link,
			job_preference: profile.job_preference,
			job_location: profile.job_location,
		});
		setJobType(profile?.job_type);
		setTravelType(profile?.travel_type);
		setMeetingRequired(profile?.meeting_required);
		setWorkerType(profile?.worker_type);
		setChosenTags(profile?.tags?.map(tag => tag.id));
		setImagePreview(profile.profile_image);
		// setSelectedTags(formatSelectedTags(profile?.tags))

		//get states
		ReqGet('states')
			.then(res => {
				setStatesData(res.data);
				const state_id = profile.state?.id || res?.data[0]?.id;

				if (state_id) {
					ReqGet('cities/' + state_id)
						.then(res => {
							setCitiesData(res.data);
						})
						.catch(err => {
							console.log(err.message);
						});
				}
			})
			.catch(err => {
				console.log(err.message);
			});

		if (profile?.tool && profile?.tool?.length > 0) {
			setTools(profile?.tool);
		}

		if (profile?.other_requirements && profile?.tool?.length > 0) {
			setOtherRequirements(profile?.other_requirements);
		}

		if (
			profile?.specific_expertise &&
			profile?.specific_expertise?.length > 0
		) {
			setExpertise(profile?.specific_expertise);
		}

		if (profile?.experiences && profile?.experiences?.length > 0) {
			setExperiences(profile?.experiences);
		}

		if (profile?.references && profile?.references?.length > 0) {
			setReferences(profile?.references);
		}
	}, [profile]);

	useEffect(() => {
		// only tag ids will be sent in request 'ChosenTags' and selectedTags used to show in dropdown field
		let selected = [];

		tags.map(tag => {
			tag.child_tags.map(child => {
				if (chosenTags.includes(child.id)) {
					selected = [
						{ label: child.display_name, value: child.id, id: child.id },
						...selected,
					];
				}
			});
		});

		setSelectedTags(selected);
	}, [chosenTags]);
	const returnedTags = formattedTags(tags);
	// function changeHandler (string){
	//     return string.split('  ').join('');
	//   }
	// console.log(chosenTags, "pakvalue")
	const changeHandler = e => {
		const newVal = _.cloneDeep(allValues);
		if (e.target.name == 'supporting_file') {
			console.log(newVal, 'abcd');

			_.update(newVal, e.target.name, () => e.target.files[0]);
		} else {
			_.update(newVal, e.target.name, () => e.target.value);
		}
		setAllValues(newVal);
	};

	const formatSelectedTags = items => {
		let changedTags = [];
		if (!items) return [];

		items.map((item, i) => {
			changedTags.push({
				label: item.display_name,
				value: item.id,
				id: item.id,
			});
		});

		return changedTags;
	};

	const imageHandler = e => {
		const imageSiz = Math.round(e?.target?.files[0]?.size / 1024);
		if (imageSiz > 510) {
			toast.error(`Image size must be less  or equal to 500kb.`);

			return;
		}
		setImageProgress(true);
		const reader = new FileReader();
		reader.onload = () => {
			if (reader.readyState === 2) {
				setImagePreview(reader.result);
				setImageProgress(false);
			}
		};

		const file = e.target.files[0];
		reader.readAsDataURL(file);
		setImage(file);
	};

	//

	const handleInputChange = (e, index, items, setItems) => {
		const { name, value } = e.target;
		const list = [...items];
		list[index][name] = value;
		setItems(list);
	};

	const handleChangeMultiInput = (e, index, items, setItems) => {
		const { value } = e.target;
		const list = [...items];
		list[index] = value;
		setItems(list);
	};

	const handleRemove = (index, items, setItem) => {
		const list = [...items];
		list.splice(index, 1);
		setItem(list);
	};

	const onClickHandler = e => {
		const getChild = [];
		selectedChild.filter(d1 => getChild.push(d1.value));
		selectedChild2nd.filter(d1 => getChild.push(d1.value));
		selectedChild2.filter(d1 => getChild.push(d1.value));
		selectedChild3.filter(d1 => getChild.push(d1.value));

		// Update the tags state with getChild
		setTags(getChild);

		// Log getChild, not tags
		console.log(getChild, 'ssasas');
		// console.log(tagsSend, "TagsvaluesetTags")

		console.log('ref', nameRef.current.value);

		if (!nameRef.current.value) {
			toast.error(`Please add first name`);

			return;
		}
		if (!lastNameRef.current.value) {
			toast.error(`Please add last name`);

			return;
		}

		e.preventDefault();

		if (userType === 'member') {
			if (
				allValues.twit_link !== null &&
				allValues?.twit_link?.length > 0 &&
				!allValues.twit_link.match(
					/(http(?:s)?:\/\/twitter.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/i
				)
			) {
				alert('Please Enter Valid Twitter Account Link');
				return;
			}

			if (
				allValues.linkedin_link !== null &&
				allValues?.linkedin_link?.length > 0 &&
				!allValues.linkedin_link.match(
					/(http(?:s)?:\/\/linkedin.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/i
				)
			) {
				alert('Please Enter Valid LinkedIn Account Link');
				return;
			}
			if (
				allValues.facebook_link !== null &&
				allValues?.facebook_link?.length > 0 &&
				!allValues.facebook_link.match(
					/(http(?:s)?:\/\/facebook.com\/(?![a-zA-Z0-9_]+\/)([a-zA-Z0-9_]+))/i
				)
			) {
				alert('Please Enter Valid Facebook Account Link');
				return;
			}

			if (allValues.job_location === null) {
				alert('Please select Location');
				return;
			}

			if (allValues.job_type === null) {
				alert('Please select Job Type');
				return;
			}

			if (
				allValues.job_location !== null &&
				allValues.job_location !== 'remote' &&
				allValues.state === null
			) {
				alert('Please select State');
				return;
			}

			if (
				allValues.job_location !== null &&
				allValues.job_location !== 'remote' &&
				allValues.city === null
			) {
				alert('Please select City');
				return;
			}
			if (!travelType) {
				toast.error(`Please select travel type`);

				return;
			}
			const expertiseResult = expertise.filter(data => {
				return data.trim().length < 1 || data.trim() == '' || data == '';
			});

			const toolsResult = tools.filter(data => {
				return data.trim().length < 1 || data.trim() == '' || data == '';
			});

			const requirementResult = otherRequirements.filter(data => {
				return data.trim().length < 1 || data.trim() == '' || data == '';
			});
			if (expertiseResult?.length >= 1 || expertise?.length < 1) {
				toast.error(`Please fill expertise`);

				return;
			}

			if (otherRequirements?.length < 1 || requirementResult?.length >= 1) {
				toast.error(`Please fill  requirment`);
				return;
			}
			if (tools?.length < 1 || toolsResult?.length >= 1) {
				toast.error(`Please fill tool`);
				return;
			}
			if (!allValues.state) {
				toast.error(`Please select a state.`);
				return;
			}
			if (!allValues.city) {
				toast.error(`Please select a city.`);

				return;
			}
			if (!allValues.first_name || !allValues.first_name.trim()) {
				toast.error(`Please add first name`);
				return;
			}
			if (!allValues.last_name || !allValues.last_name.trim()) {
				toast.error(`Please add last name`);
				return;
			}
		} else {
			if (!allValues.first_name || !allValues.first_name.trim()) {
				toast.error(`Please add first name`);
				return;
			}
			if (!allValues.last_name || !allValues.last_name.trim()) {
				toast.error(`Please add last name`);
				return;
			}
		}

		const data = new FormData();
		//   hide 'email2' from fields
		const fields = [
			'first_name',
			'middle_name',
			'last_name',
			'company_name',
			// "division_name",
			'email',
			'phone',
			'phone2',
			'start_date',
			'end_date',
			'professional_title_id',
			'year_experience',
			'job_preference',
			'address',
			'city',
			'state',
			'zip',
			'twit_link',
			'linkedin_link',
			'facebook_link',
			'available_start',
			'available_end',
			'available',
			'job_location',
			'job_type',
			'supporting_file',
		];

		fields.map(field => {
			if (allValues[field] !== null && allValues[field] !== undefined)
				data.append(field, allValues[field]);
		});

		// data.append('tag_parent_id', parentTag.value)
		!emailRef.current.value
			? data.append('email2', '')
			: data.append('email2', allValues.email2);
		data.append('profile_image', image);
		data.append('first_name', allValues.first_name.trim());

		if (allValues.middle_name != null) {
			data.append('middle_name', allValues.middle_name.trim());
		}
		if (allValues.year_experience != null) {
			data.append('year_experience', allValues.year_experience.trim());
		}
		// data.append("middle_name", allValues.middle_name.trim());
		data.append('last_name', allValues.last_name.trim());
		if (allValues.company_name != null) {
			data.append('company_name', allValues.company_name.trim());
		}
		// data.append("division_name", allValues.division_name.trim());
		data.append('experiences', JSON.stringify(experiences));
		data.append('specific_expertise', JSON.stringify(expertise));
		data.append('tool', JSON.stringify(tools));
		data.append('other_requirements', JSON.stringify(otherRequirements));
		data.append('references', JSON.stringify(references));
		data.append('tags', JSON.stringify(getChild));
		data.append('job_type', jobType);
		data.append('worker_type', workerType);
		data.append('travel_type', travelType);
		data.append('meeting_required', meetingRequired);

		setImageProgress(true);
		ReqPost('profile', data)
			.then(res => {
				if (res.status === 200) {
					setImageProgress(false);
					toast.success(`Profile updated successfully.`);

					const profile = JSON.parse(
						localStorage.getItem('cogen_user_profile')
					);

					profile.user = res.data;
					localStorage.setItem('cogen_user_profile', JSON.stringify(profile));
					navigate('/');
				} else {
					setImageProgress(false);
					toast.error(res.data.message);
				}
			})
			.catch(err => {
				console.log(err);
				setImageProgress(false);
				toast.error('something went wrong.');

				navigate('/');
			});
	};

	// helo[akistan]

	const formatGroupLabel = data => (
		<div style={groupStyles}>
			<span>{data.label}</span>
			<span style={groupBadgeStyles}>{data.options.length}</span>
		</div>
	);

	const titlesChangeHandler = (option, e) => {
		console.log(option);
		setAllValues({
			...allValues,
			[e.name]: option.id,
		});
	};

	const SetJoblocation = e => {
		console.log(e.currentTarget.value);
		setAllValues({
			...allValues,
			job_location: e.currentTarget.value,
		});
	};

	const SetTravelType = e => {
		setTravelType(e.target.value);
	};
	const SetMeetingRequired = e => {
		setMeetingRequired(e.target.value);
	};

	const SetWorkType = e => {
		setWorkerType(e.target.value);
	};

	const SetCity = e => {
		console.log(e.currentTarget.value);
		setAllValues({
			...allValues,
			city: e.currentTarget.value,
		});
	};

	const loadcities = id => {
		console.log(id);
		ReqGet('cities/' + id)
			.then(res => {
				setCitiesData(res.data);
			})
			.catch(err => {
				console.log(err.message);
			});

		setAllValues({
			...allValues,
			state: id,
		});
	};

	// const loadChildTags = (tag_parent_id) => {
	//   ReqGet(`child-tags/${tag_parent_id}`).then(res => {
	//     setChildTags(formattedTags(res.data.data))
	//   })
	//     .catch(err => {
	//       console.log(err.message);
	//     })
	// }

	// const selectTags = (tags) => {
	//   let selected = []
	//   tags.map((data, i) => {
	//     selected.push(data.value)
	//   })
	//   setChosenTags(selected)
	// }
	//
	const params = {
		child_tag_1: childChecked,
		child_tag_2: childChecked2,
	};

	// 1st Parent
	const selectParentTag = (e, d1) => {
		const { checked, value } = e.target;
		console.log(d1, 'hellooooddaaaaa');
		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent([d1]);
			setChecked1([d1.value]);
		} else {
			setSelectredParent([]);
			setChecked1([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags(formattedTags(res.data.data));
					setChildTags2nd(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags([]);
			setChildTags2nd([]);
			setChildChecked([]);
			setChildChecked2nd([]);
			setSelectedChild([]);
			setSelectedChild2nd([]);
		}
		setChildChecked([]);
		setChildChecked2nd([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	// 2nd Parent
	const selectParentTag2 = (e, d1) => {
		const { checked, value } = e.target;

		setParent(d1.label);
		if (e.target.checked) {
			setSelectredParent2([d1]);
			setChecked2([d1.value]);
		} else {
			setSelectredParent2([]);
			setChecked2([]);
		}
		if (checked) {
			ReqGet(`child-tags/${d1.value}`)
				.then(res => {
					setChildTags2(formattedTags(res.data.data));
					setChildTags3(formattedTags(res.data.data));
				})
				.catch(err => {
					console.log(err.message);
				});
		} else {
			setChildTags2([]);
			setChildTags3([]);
			setChildChecked2([]);
			setChildChecked3([]);
			setSelectedChild2([]);
			setSelectedChild3([]);
		}
		setChildChecked2([]);
		setChildChecked3([]);
		setParentShow(false);
		setChildrenShow(true);
	};

	//1st Child

	const childSelection = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked([...childChecked, result.value]);
			setSelectedChild([...selectedChild, result]);
		} else {
			let f1 = [...selectedChild];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild([...f1]);
		}
	};

	// 2nd
	const childSelection2nd = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2nd([...childChecked2nd, result.value]);
			setSelectedChild2nd([...selectedChild2nd, result]);
		} else {
			let f1 = [...selectedChild2nd];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2nd];

			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2nd(checkCild);
			console.log(f1, 'f11111111111');
			console.log('result', result);
			return setSelectedChild2nd([...f1]);
		}
	};

	/// 3rd child
	const childSelection2 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked2([...childChecked2, result.value]);
			setSelectedChild2([...selectedChild2, result]);
		} else {
			let f1 = [...selectedChild2];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked2];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked2(checkCild);

			return setSelectedChild2([...f1]);
		}
	};

	// 4th child
	const childSelection3 = e => {
		const { checked, value } = e.target;
		const result = JSON.parse(value);

		if (checked) {
			setChildChecked3([...childChecked3, result.value]);
			setSelectedChild3([...selectedChild3, result]);
		} else {
			let f1 = [...selectedChild3];
			f1 = f1.filter(d1 => d1.value != result.value);
			let checkCild = [...childChecked3];
			checkCild = checkCild.filter(d1 => d1 != result.value);
			setChildChecked3(checkCild);

			return setSelectedChild3([...f1]);
		}
	};
	///
	const okFun = () => {
		if (selectedChild.length < 1) {
			toast.error(`Please select atleast 1 children tag`);

			return;
		}
		setChildrenShow(false);
		// setSelectedChild([])
		setChildSelected([...selectedChild]);
	};
	const showParent = () => {
		setParentShow(true);
		setChildrenShow(false);
	};
	const removeTag = id => {
		setChildSelected(childSelected.filter(d2 => d2.value != id));
		setSelectedChild(selectedChild.filter(d1 => d1.value != id));

		setActiveList(activeList.filter(d1 => d1 != id));
	};
	//
	const hideParentTag = () => {
		setParentShow(false);
	};
	const hideChildrenTag = tag1 => {
		if (selectedChild.length < 1 && tag1 !== 'cross') {
			toast.error(`Please select at least 1 Child Tag`);
		}
		setChildrenShow(false);
	};

	return (
		<Container fluid='md' className='mt-3'>
			{imageProgress ? (
				<div className='lds-ring'>
					<div></div>
					<div></div>
					<div></div>
					<div></div>
				</div>
			) : (
				<div>
					<Row>
						<Col sm={10}></Col>
						<Col sm={2}>
							<Button
								style={{ marginLeft: '50px' }}
								className='btn_cancel'
								variant='primary'
								onClick={_handleEdit}
							>
								Back{' '}
							</Button>
						</Col>
					</Row>
					{/* Profile */}
					<Form style={{ border: '1px solid', marginTop: '12px' }}>
						<Row>
							<Col sm={12}>
								<div
									className={'top-actions bg-label'}
									style={{ borderBottom: ' 1px solid' }}
								>
									<h4
										className={'heading text-orange fw-bold p-2 ms-2 rounded'}
									>
										Profile
									</h4>
								</div>
							</Col>
						</Row>

						<ul className='list-group list-group-flush'>
							<li className='list-group-item fw-bold'>
								<Row>
									<Col md={8}>
										<Row>
											<Col md={7}>
												<InputGroup controlId='formBasicEmail'>
													<>
														<InputGroup.Text className='fw-bold'>
															First Name<span style={{ color: 'red' }}>*</span>
														</InputGroup.Text>
													</>
													{/* <Form.Label className="fw-bold">First Name:<span style={{ color: 'red' }}>*</span></Form.Label> */}
													<FormControl
														type='text'
														ref={nameRef}
														name='first_name'
														id='extraSpace'
														maxlength='20'
														onChange={changeHandler}
														placeholder='Enter First Name'
														defaultValue={allValues.first_name}
														required
													/>
												</InputGroup>
											</Col>
											<Col md={5}>
												<InputGroup controlId='formBasicEmail'>
													<>
														<InputGroup.Text className='fw-bold'>
															Middle Name
														</InputGroup.Text>
													</>
													{/* <Form.Label className="fw-bold">First Name:<span style={{ color: 'red' }}>*</span></Form.Label> */}
													<FormControl
														type='text'
														// ref={nameRef}
														name='middle_name'
														id='extraSpace'
														maxlength='20'
														onChange={changeHandler}
														placeholder='Enter Middle Name'
														defaultValue={allValues.middle_name}
														required
													/>
												</InputGroup>
											</Col>
										</Row>
										<InputGroup
											controlId='formBasicEmail'
											style={{ marginTop: '22px' }}
										>
											<>
												<InputGroup.Text className='fw-bold'>
													Last Name<span style={{ color: 'red' }}>*</span>
												</InputGroup.Text>
											</>
											{/* <Form.Label className="fw-bold">First Name:<span style={{ color: 'red' }}>*</span></Form.Label> */}
											<FormControl
												ref={lastNameRef}
												type='text'
												name='last_name'
												maxlength='20'
												onChange={changeHandler}
												placeholder='Enter Last Name'
												defaultValue={allValues.last_name}
												required
											/>
										</InputGroup>
										{/* <Form.Group controlId="formBasicEmail">
                      <Form.Label className="fw-bold">
                        Last Name:<span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        ref={lastNameRef}
                        type="text"
                        name="last_name"
                        maxlength="20"
                        onChange={changeHandler}
                        placeholder="Enter Last Name"
                        defaultValue={allValues.last_name}
                        required
                      />
                    </Form.Group> */}
									</Col>
									<Col md={4} className=' text-end'>
										<div
											style={{
												display: 'inline-block',
												borderRadius: '1rem',
												cursor: 'pointer',
											}}
										>
											<MdOutlineFileUpload id='uploadIcon' />
											{!imageProgress ? (
												<img
													className='profile'
													style={{ padding: '0px' }}
													src={imagePreview}
													alt='profile'
													onClick={e => profileImage.current.click()}
												/>
											) : (
												<div className='lds-ring'>
													<div></div>
													<div></div>
													<div></div>
													<div></div>
												</div>
											)}
											<input
												type='file'
												accept='image/*'
												id='input'
												onChange={imageHandler}
												style={{ display: 'none' }}
												ref={profileImage}
											/>
										</div>
									</Col>
								</Row>
							</li>
						</ul>

						<Row
							className='bg-label mt-4'
							style={{
								width: '98.6%',
								marginLeft: '15px',
								borderLeft: '1px solid',
								borderBottom: ' 1px solid',
								borderTop: ' 1px solid',
							}}
						>
							<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
								{' '}
								Contact Information{' '}
							</Col>
						</Row>
						<Row
							style={{
								borderLeft: '1px solid',
								borderBottom: ' 1px solid',
								width: '98.6%',
								marginLeft: '15px',
							}}
						>
							<Col sm={12}>
								{/* Job Title */}

								<ul className='list-group list-group-flush'>
									{userType === 'Member' || userType === 'member' ? (
										<Row
											style={{
												marginTop: '15px',
												marginBottom: '15px',
											}}
										>
											<Col md={12}>
												<InputGroup controlId='formBasicEmail'>
													<>
														<InputGroup.Text className='fw-bold'>
															Professional Titles
															{/* <span style={{ color: "red" }}>*</span> */}
														</InputGroup.Text>
													</>
													<Col md={6} style={{ marginLeft: '-15px' }}>
														<Select
															name='professional_title_id'
															value={titles.filter(function (option) {
																return (
																	option.id === allValues.professional_title_id
																);
															})}
															defaultValue={titles.filter(function (option) {
																return (
																	option.id === allValues.professional_title_id
																);
															})}
															options={titles}
															formatGroupLabel={formatGroupLabel}
															onChange={titlesChangeHandler}
															getOptionLabel={titles => titles.name}
															getOptionValue={titles => titles.id}
														/>
													</Col>
												</InputGroup>
											</Col>
										</Row>
									) : null}

									{/*Year Experience */}
									<Row
										style={{
											marginTop: '15px',
										}}
									>
										{userType === 'Member' ||
											(userType === 'member' && (
												<Col sm={6}>
													<InputGroup
														controlId='formBasicEmail'
														className='mb-4'
													>
														<>
															<InputGroup.Text className='fw-bold'>
																Years Experience:
															</InputGroup.Text>
														</>
														<Form.Control
															as='select'
															custom
															name='year_experience'
															onChange={changeHandler}
															value={allValues.year_experience}
															required
														>
															<option disabled selected>
																Select Year Experience
															</option>
															<option value='1-3'>1-3</option>
															<option value='4-6'>4-6</option>
															<option value='7-10'>7-10</option>
															<option value='10+'>10+</option>
														</Form.Control>
													</InputGroup>
												</Col>
											))}

										<Col sm={6}></Col>
									</Row>
									{/*  */}
									<Row
										style={{
											marginTop: '15px',
											marginBottom: '15px',
										}}
									>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Company
														{/* <span style={{ color: "red" }}>*</span> */}
													</InputGroup.Text>
												</>
												<FormControl
													type='text'
													name='company_name'
													id='company_name'
													maxlength='60'
													onChange={changeHandler}
													placeholder='Enter Company'
													defaultValue={allValues.company_name}
												/>
											</InputGroup>
										</Col>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text>
														* Enter company name if applicable
													</InputGroup.Text>
												</>
												{/* <FormControl
                          type="text"
                          name="division_name"
                          id="division_name"
                          maxlength="90"
                          onChange={changeHandler}
                          placeholder="Enter Company Name"
                          defaultValue={allValues.division_name}
                        /> */}
											</InputGroup>
										</Col>
									</Row>
									{/*  */}
									<Row
										style={{
											marginTop: '15px',
											marginBottom: '15px',
										}}
									>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Mobile Phone #
														{/* <span style={{ color: "red" }}>*</span> */}
													</InputGroup.Text>
												</>
												<FormControl
													mask='+1 (999) 999-9999'
													className='form-control'
													name='phone'
													value={allValues.phone}
													onChange={changeHandler}
												/>
											</InputGroup>
										</Col>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Second Phone #
													</InputGroup.Text>
												</>
												<FormControl
													mask='+1 (999) 999-9999'
													className='form-control'
													name='phone2'
													value={allValues.phone2}
													onChange={changeHandler}
												/>
											</InputGroup>
										</Col>
									</Row>
									{/*  */}
									<Row
										style={{
											marginTop: '15px',
											marginBottom: '15px',
										}}
									>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Work Email
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>
												</>
												<FormControl
													name='email'
													onChange={changeHandler}
													type='email'
													placeholder='Enter Email'
													defaultValue={allValues.email}
													readOnly
													required
												/>
											</InputGroup>
										</Col>
										<Col md={6}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Personal Email
													</InputGroup.Text>
												</>
												<FormControl
													ref={emailRef}
													name='email2'
													onChange={changeHandler}
													type='email'
													placeholder='Enter Email'
													defaultValue={allValues.email2}
													required
												/>
											</InputGroup>
										</Col>
									</Row>
									{/*  */}
									<Row
										style={{
											marginTop: '15px',
											marginBottom: '15px',
										}}
									>
										<Col md={12}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Address
														<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>
												</>
												<FormControl
													cols={1}
													as='textarea'
													type='text'
													name='address'
													onChange={changeHandler}
													placeholder='Enter Address'
													defaultValue={allValues.address}
												/>
											</InputGroup>
										</Col>
									</Row>
									{/*  */}
									<Row
										style={{
											marginTop: '15px',
											marginBottom: '15px',
										}}
									>
										<Col md={5}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														City<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>
												</>
												<Form.Control
													as='select'
													value={allValues.city}
													custom
													name='cities'
													onChange={SetCity}
													placeholder='Select city'
													required
												>
													<option value=''>Select City</option>
													return(
													{citiesData.map((item, i) => {
														return (
															<option key={i} value={item.id}>
																{item.name}
															</option>
														);
													})}
													)
												</Form.Control>
											</InputGroup>
										</Col>
										<Col md={5}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														State<span style={{ color: 'red' }}>*</span>
													</InputGroup.Text>
												</>
												<Form.Control
													as='select'
													value={allValues.state}
													custom
													name='state'
													onChange={event => loadcities(event.target.value)}
													placeholder='Select State'
													required
												>
													<option value=''>Select State</option>
													return(
													{statesData.map((item, i) => {
														return (
															<option key={i} value={item.id}>
																{item.name}
															</option>
														);
													})}
													)
												</Form.Control>
											</InputGroup>
										</Col>
										<Col md={2}>
											<InputGroup controlId='formBasicEmail'>
												<>
													<InputGroup.Text className='fw-bold'>
														Zip
													</InputGroup.Text>
												</>
												<FormControl
													name='zip'
													onChange={changeHandler}
													type='number'
													min='0'
													placeholder='Zip'
													defaultValue={allValues.zip}
													required
												/>
											</InputGroup>
										</Col>
									</Row>
									{/*  */}
									{/* <li className="list-group-item fw-bold">
                    <Row>
                      <Col md={5}>
                        <Form.Group controlId="newStates">
                          <Form.Label className="fw-bold">
                            {userType === "Member" || userType === "member" ? (
                              <>
                                States:<span style={{ color: "red" }}>*</span>
                              </>
                            ) : (
                              "States"
                            )}
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={allValues.state}
                            custom
                            name="state"
                            onChange={(event) => loadcities(event.target.value)}
                            placeholder="Select State"
                            required
                          >
                            <option value="">Select State</option>
                            return(
                            {statesData.map((item, i) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                            )
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group controlId="newCities">
                          <Form.Label className="fw-bold">
                            {userType === "Member" || userType === "member" ? (
                              <>
                                Cities:<span style={{ color: "red" }}>*</span>
                              </>
                            ) : (
                              "Cities"
                            )}
                          </Form.Label>
                          <Form.Control
                            as="select"
                            value={allValues.city}
                            custom
                            name="cities"
                            onChange={SetCity}
                            placeholder="Select city"
                            required
                          >
                            <option value="">Select City</option>
                            return(
                            {citiesData.map((item, i) => {
                              return (
                                <option value={item.id}>{item.name}</option>
                              );
                            })}
                            )
                          </Form.Control>
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                       
                        <Form.Group controlId="newCities">
                          <Form.Label className="fw-bold">
                            Zip:
                          </Form.Label>
                          <Form.Control
                            
                            name="zip"
                            onChange={changeHandler}
                            type="number"
                            min="0"
                            placeholder="Enter Zip"
                            defaultValue={allValues.zip}
                            required
                          />
                        </Form.Group>
                       
                      </Col>
                    </Row>
                  </li> */}
								</ul>
							</Col>
						</Row>
						<Row>
							<Col>
								<Row
									className='bg-label mt-4'
									style={{
										width: '98.6%',
										marginLeft: '15px',
										borderLeft: '1px solid',
										borderBottom: ' 1px solid',
										borderTop: ' 1px solid',
									}}
								>
									<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
										{' '}
										Social Media Links:{' '}
									</Col>
								</Row>
								<div className='mb-2'>
									<Stack gap={2} style={{ marginTop: '10px' }}>
										<Form.Group controlId='formBasicEmail mt-2'>
											<InputGroup
												className='mb-1 ms-4'
												style={{ width: '60%' }}
											>
												<>
													<InputGroup.Text className='fw-bold'>
														<img
															src={linkedin}
															alt='linkedin'
															style={{ width: '20px' }}
														/>
														LinkedIn
													</InputGroup.Text>
												</>
												<Form.Control
													name='linkedin_link'
													onChange={changeHandler}
													type='text'
													placeholder='Enter linkedin link'
													defaultValue={allValues.linkedin_link}
												/>
											</InputGroup>
										</Form.Group>
										<Form.Group controlId='formBasicEmail'>
											<InputGroup
												className='mb-1 ms-4'
												style={{ width: '60%' }}
											>
												<>
													<InputGroup.Text className='fw-bold'>
														<img
															src={tw}
															alt='twitter'
															style={{ width: '20px' }}
														/>
														Twitter
													</InputGroup.Text>
												</>
												<Form.Control
													name='twit_link'
													onChange={changeHandler}
													type='text'
													placeholder='Enter twitter link'
													defaultValue={allValues.twit_link}
												/>
											</InputGroup>
										</Form.Group>
										<Form.Group controlId='formBasicEmail'>
											<InputGroup
												className='mb-1 ms-4'
												style={{ width: '60%' }}
											>
												<>
													<InputGroup.Text className='fw-bold'>
														<img
															src={fb}
															alt='Facebook'
															style={{ width: '20px' }}
														/>
														Facebook
													</InputGroup.Text>
												</>
												<Form.Control
													name='facebook_link'
													onChange={changeHandler}
													type='text'
													placeholder='Enter Facebook link'
													defaultValue={allValues.facebook_link}
												/>
											</InputGroup>
										</Form.Group>
									</Stack>
								</div>
								<Row>
									<Col md={12}></Col>
									<Col md={12}></Col>
								</Row>
							</Col>
						</Row>
					</Form>
					<Row>
						<Col>
							{userType === 'Member' || userType === 'member' ? (
								<>
									{/* Professional Expertise   */}
									<Form
										style={{
											border: '1px solid',
											marginTop: '12px',
											marginBottom: '10px',
										}}
									>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Professional Expertise
													</h4>
												</div>
											</Col>
										</Row>
										{/* Select General & Specific Expertise */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Select General & Specific Expertise{' '}
												<span style={{ color: 'red' }}>*</span>{' '}
												<span
													style={{ fontWeight: 'bold', marginLeft: '150px' , fontSize:'12px'}}
												>
													Note:
												</span>
												<span style={{ fontWeight: '600', marginLeft: '6px', fontSize:'12px' }}>
												Please select at least one Primary General and one Specific Field{' '}
												</span>
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Row
												style={{
													marginTop: '15px',
													marginBottom: '15px',
												}}
											>
												<Col md={4}>
													<InputGroup
														controlId='formBasicEmail'
														style={{ marginLeft: '12px' }}
													>
														<>
															<InputGroup.Text
																className='fw-bold'
																style={{ width: '94px' }}
															>
																Primary <br /> General
															</InputGroup.Text>
														</>
														{/*  Parent  */}
														<ParentTagsScreen
															selectedParent={selectedParent}
															// header="Select Parent Tag"
															hideParentTag={hideParentTag}
															returnedTags={returnedTags}
															selectParentTag={selectParentTag}
															checked={checked1}
														/>
													</InputGroup>
												</Col>
												{/* 1st child */}
												<Col md={4} style={{ marginLeft: '34px' }}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Specific <br /> Field 1
															</InputGroup.Text>
														</>
														{/* /// showChildren */}
														<NewChildTag
															// header="Select Child Tag"
															hideChildrenTag={hideChildrenTag}
															parent={parent}
															activeList={activeList}
															childTags={childTags}
															childSelection={childSelection}
															selectedChild={selectedChild}
															showParent={showParent}
															childChecked={childChecked}
														/>
													</InputGroup>
												</Col>
												{/* 2nd child */}
												<Col md={3}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Specific <br /> Field 2
															</InputGroup.Text>
														</>
														{selectedChild.length >= 1 && (
															<NewChildTag
																// header="Select Child Tag"
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags2nd}
																childSelection={childSelection2nd}
																selectedChild={selectedChild2nd}
																// showParent={showParent}
																childChecked={childChecked2nd}
															/>
														)}
													</InputGroup>
												</Col>
											</Row>
											{/* {selectedChild.length >= 1 && ( */}
											<Row
												style={{
													marginTop: '15px',
													marginBottom: '15px',
												}}
											>
												<Col md={4}>
													<InputGroup
														controlId='formBasicEmail'
														style={{ marginLeft: '10px' }}
													>
														<>
															<InputGroup.Text
																className='fw-bold'
																style={{ width: '96px' }}
															>
																Secondary <br /> General
															</InputGroup.Text>
														</>
														{/*  Parent  */}
														<ParentTagsScreen
															selectedParent={selectedParent2}
															// header="Select Parent Tag"
															hideParentTag={hideParentTag}
															returnedTags={returnedTags}
															selectParentTag={selectParentTag2}
															checked={checked2}
														/>
													</InputGroup>
												</Col>
												{/* 3rd child */}
												<Col md={4} style={{ marginLeft: '32px' }}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Specific <br /> Field 1
															</InputGroup.Text>
														</>
														{/* /// showChildren */}
														<NewChildTag
															// header="Select Child Tag"
															hideChildrenTag={hideChildrenTag}
															parent={parent}
															activeList={activeList}
															childTags={childTags2}
															childSelection={childSelection2}
															showParent={showParent}
															selectedChild={selectedChild2}
															childChecked={childChecked2}
														/>
													</InputGroup>
												</Col>
												{/* 4th child */}
												<Col md={3}>
													<InputGroup controlId='formBasicEmail'>
														<>
															<InputGroup.Text className='fw-bold'>
																Specific <br /> Field 2
															</InputGroup.Text>
														</>
														{selectedChild2.length >= 1 && (
															<NewChildTag
																hideChildrenTag={hideChildrenTag}
																parent={parent}
																activeList={activeList}
																childTags={childTags3}
																childSelection={childSelection3}
																// showParent={showParent}
																selectedChild={selectedChild3}
																childChecked={childChecked3}
															/>
														)}
													</InputGroup>
												</Col>
											</Row>

											{/* )} */}

											{/* <Col>
                        <div style={{ marginTop: "10px" }}>
                          <Form.Group controlId="Tags">
                            <div style={{ display: "flex" }}>
                              <div
                                style={{
                                  borderRadius: "10px",
                                  alignItems: "center",
                                  width: "65%",
                                  position: "relative",
                                  left: 0,
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                  }}
                                >
                               

                             
                                  
                                  
                                </div>
                                <br />
                                {selectedChild.length >= 1 && (
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <div style={{ width: "50%" }}>
                                     

                                      <ParentTagsScreen
                                        selectedParent={selectedParent2}
                                        header="Select Parent Tag"
                                        hideParentTag={hideParentTag}
                                        returnedTags={returnedTags}
                                        selectParentTag={selectParentTag2}
                                        checked={checked2}
                                      />
                                    </div>
                                    <div style={{ width: "50%" }}>
                                     

                                      <NewChildTag
                                        header="Select Child Tag"
                                        hideChildrenTag={hideChildrenTag}
                                        parent={parent}
                                        activeList={activeList}
                                        childTags={childTags2}
                                        childSelection={childSelection2}
                                        showParent={showParent}
                                        selectedChild={selectedChild2}
                                        childChecked={childChecked2}
                                      />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </Form.Group>
                        </div>
                      </Col> */}
										</Row>

										{/*Specialized Professional Skills  */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Specialized Professional Skills{' '}
												<span style={{ color: 'red' }}>*</span>{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{expertise?.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			maxlength='800'
																			style={{marginBottom:'10px'}}
																			name='first_name'
																			onChange={e =>
																				handleChangeMultiInput(
																					e,
																					i,
																					expertise,
																					setExpertise
																				)
																			}
																			as='textarea' 
																			rows='1'
																			placeholder='Add Expertise'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<div className='btn-box'>
																		{/* <Button variant="outline-success">Success</Button> */}
																		{expertise.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() =>
																					handleRemove(
																						i,
																						expertise,
																						setExpertise
																					)
																				}
																			>
																				Remove this expertise
																			</Button>
																		)}
																		{expertise.length - 1 === i &&
																			expertise.length < 10 && (
																				<Button
																					variant='outline-success'
																					onClick={() =>
																						setExpertise([...expertise, ''])
																					}
																				>
																					Add an Expertise
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
										{/* Additional Skills */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Additional Skills{' '}
												<span style={{ color: 'red' }}>*</span>{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{otherRequirements.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			maxlength='800'
																			style={{marginBottom:'10px'}}
																			name='requirement'
																			onChange={e =>
																				handleChangeMultiInput(
																					e,
																					i,
																					otherRequirements,
																					setOtherRequirements
																				)
																			}
																			as='textarea' 
																			rows='1'
																			placeholder='Add Other Skills'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<div className='btn-box'>
																		{otherRequirements?.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() =>
																					handleRemove(
																						i,
																						otherRequirements,
																						setOtherRequirements
																					)
																				}
																			>
																				Remove this Other Skills
																			</Button>
																		)}
																		{otherRequirements.length - 1 === i &&
																			otherRequirements.length < 10 && (
																				<Button
																					variant='outline-success'
																					onClick={() =>
																						setOtherRequirements([
																							...otherRequirements,
																							'',
																						])
																					}
																				>
																					Add an Other Skills
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
										{/* Tool Required/Recommended */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Tool Required/Recommended{' '}
												<span style={{ color: 'red' }}>*</span>{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '16px',
											}}
										>
											<Col>
												<ul className='list-group list-group-flush'>
													<li className='list-group-item fw-bold'>
														{tools?.map((item, i) => {
															return (
																<div key={i}>
																	<Form.Group controlId='formBasicEmail'>
																		<Form.Control
																			maxlength='800'
																			style={{marginBottom:'10px'}}
																			name='tools'
																			onChange={e =>
																				handleChangeMultiInput(
																					e,
																					i,
																					tools,
																					setTools
																				)
																			}
																			as='textarea' 
																			rows='1'
																			placeholder='Add Tool'
																			defaultValue={item}
																			value={item}
																		/>
																	</Form.Group>
																	<div className='btn-box'>
																		{tools?.length !== 1 && (
																			<Button
																				variant='outline-danger'
																				style={{
																					marginRight: '48px',
																					marginBottom: '6px',
																				}}
																				onClick={() =>
																					handleRemove(i, tools, setTools)
																				}
																			>
																				Remove this Tool
																			</Button>
																		)}
																		{tools.length - 1 === i &&
																			tools.length < 10 && (
																				<Button
																					variant='outline-success'
																					onClick={() =>
																						setTools([...tools, ''])
																					}
																				>
																					Add Tool
																				</Button>
																			)}
																	</div>
																</div>
															);
														})}
													</li>
												</ul>
											</Col>
										</Row>
									</Form>

									{/* Location and Travel Choices */}
									<Form
										style={{
											border: '1px solid',
											marginTop: '12px',
											marginBottom: '10px',
										}}
									>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Location and Travel Choices
													</h4>
												</div>
											</Col>
										</Row>

										{/*Location Preference  */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Location Preference{' '}
												{/* <span style={{ color: "red" }}>*</span>{" "} */}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Form.Group
												controlId='newJobLocation'
												style={{ marginTop: '15px', marginLeft: '18px' }}
											>
												<div key={`custom-inline-checkbox`} className='mb-2'>
													<Form.Check
														custom
														inline
														label='On-Site'
														checked={allValues.job_location === 'onsite'}
														value='onsite'
														name='job_location'
														onChange={SetJoblocation}
														type={`radio`}
														id={`custom-inline-checkbox-1`}
													/>
													<Form.Check
														custom
														inline
														label='Remote'
														checked={allValues.job_location === 'remote'}
														value='remote'
														name='job_location'
														onChange={SetJoblocation}
														type={`radio`}
														id={`custom-inline-checkbox-2`}
													/>
													<Form.Check
														custom
														inline
														label='Both'
														checked={allValues.job_location === 'both'}
														value='both'
														name='job_location'
														onChange={SetJoblocation}
														type={`radio`}
														id={`custom-inline-checkbox-3`}
													/>
													{/* {errors.job_location && touched.job_location ? <div className={`red mb-1 fs15`} >{errors.job_location}</div> : null} */}
												</div>
											</Form.Group>
										</Row>
										{/* On-Site Meetings Required */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												On-Site Meetings Required{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Form.Group
												controlId='newJobLocation'
												style={{ marginTop: '15px', marginLeft: '18px' }}
											>
												<Form.Check
													custom
													inline
													label='Yes'
													checked={meetingRequired === 'yes'}
													value='yes'
													name='meeting_required'
													onChange={e => SetMeetingRequired(e)}
													type={`radio`}
													id={`meeting_required_yes`}
												/>
												<Form.Check
													custom
													inline
													label='No'
													checked={meetingRequired === 'no'}
													value='no'
													name='meeting_required'
													onChange={e => SetMeetingRequired(e)}
													type={`radio`}
													id={`meeting_required_no`}
												/>
											</Form.Group>
										</Row>

										{/* Travel Choices */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Travel Choices{' '}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '15px',
											}}
										>
											<Form.Group
												style={{ marginTop: '15px', marginLeft: '18px' }}
												controlId='newTravelType'
											>
												<div key={`custom-inline-checkbox`} className='mb-3'>
													<Form.Check
														custom
														inline
														label='No Travel'
														checked={travelType === 'NoTravel'}
														value='NoTravel'
														name='travel_type'
														onChange={e => SetTravelType(e)}
														type={`radio`}
														id={`travel_typetravel_type`}
													/>
													<Form.Check
														custom
														inline
														label='In-State'
														checked={travelType === 'InState'}
														value='InState'
														name='travel_type'
														onChange={e => SetTravelType(e)}
														type={`radio`}
														id={`travel_typetravel_type1`}
													/>
													<Form.Check
														custom
														inline
														label='In-State and Domestic (US Only)'
														checked={travelType === 'Domestic'}
														value='Domestic'
														name='travel_type'
														onChange={e => SetTravelType(e)}
														type={`radio`}
														id={`travel_type2`}
													/>
													<Form.Check
														custom
														inline
														label='International, Domestic, and In-State'
														checked={travelType === 'International'}
														value='International'
														name='travel_type'
														onChange={e => SetTravelType(e)}
														type={`radio`}
														id={`travel_type3`}
													/>
													{/* {errors.job_location && touched.job_location ? <div className={`red mb-1 fs15`} >{errors.job_location}</div> : null} */}
												</div>
											</Form.Group>
										</Row>
									</Form>

									{/* Job Profile */}
									<Form
										style={{
											border: '1px solid',
											marginTop: '12px',
											marginBottom: '10px',
										}}
									>
										<Row>
											<Col sm={12}>
												<div
													className={'top-actions bg-label'}
													style={{ borderBottom: ' 1px solid' }}
												>
													<h4
														className={
															'heading text-orange fw-bold p-2 ms-2 rounded'
														}
													>
														Job Profile
													</h4>
												</div>
											</Col>
										</Row>

										{/*Worker Type  */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Worker Type{' '}
												{/* <span style={{ color: "red" }}>*</span>{" "} */}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
											}}
										>
											<Form.Group
												controlId='newJobDestination'
												style={{ marginTop: '15px' }}
												className='ms-0'
											>
												<div
													key={`custom-inline-checkbox`}
													style={{ marginLeft: '18px' }}
												>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === '1099-subcontractor'}
														onChange={SetWorkType}
														label='1099 Subcontractor'
														value='1099-subcontractor'
														type={`radio`}
														id={`job-type-1099-subcontractor`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === 'w2-contingent-worker'}
														onChange={SetWorkType}
														value='w2-contingent-worker'
														label='W-2 Contingent Worker'
														type={`radio`}
														id={`job-type-w2-contingent-worker`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={
															workerType === 'W-2-Contingent-to-Direct-Hire'
														}
														onChange={SetWorkType}
														value='W-2-Contingent-to-Direct-Hire'
														label='W-2 Contingent to Direct Hire'
														type={`radio`}
														id={`job-type-W-2-Contingent-to-Direct-Hire`}
													/>
													<Form.Check
														custom
														inline
														name='job_type'
														checked={workerType === 'Direct-Hire-Only'}
														onChange={SetWorkType}
														value='Direct-Hire-Only'
														label='Direct Hire Only'
														type={`radio`}
														id={`job-type-Direct-Hire-Only`}
													/>
												</div>
											</Form.Group>
										</Row>
										{/* Job Type */}
										<Row
											className='bg-label mt-4'
											style={{
												width: '98.6%',
												marginLeft: '15px',
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												borderTop: ' 1px solid',
											}}
										>
											<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
												{' '}
												Job Type{' '}
												{/* <span style={{ color: "red" }}>*</span>{" "} */}
											</Col>
										</Row>
										<Row
											style={{
												borderLeft: '1px solid',
												borderBottom: ' 1px solid',
												width: '98.6%',
												marginLeft: '15px',
												marginBottom: '15px',
											}}
										>
											<Form.Group
												controlId='newJobDestination'
												style={{ marginTop: '15px' }}
												className='ms-0'
											>
												<div
													key={`custom-inline-checkbox`}
													style={{ marginLeft: '18px' }}
												>
													<Form.Check
														custom
														inline
														label='Full Time'
														name='jobType'
														type='radio'
														id='fullTime'
														checked={jobType === 'fullTime'}
														value='fullTime'
														onChange={() => {
															setJobType('fullTime');
														}}
													/>
													<Form.Check
														custom
														inline
														label='Part Time'
														name='jobType'
														type='radio'
														id='halfTime'
														checked={jobType === 'halfTime'}
														value='halfTime'
														onChange={() => {
															setJobType('halfTime');
														}}
													/>
													<Form.Check
														custom
														inline
														label='Full Time and Part Time'
														name='jobType'
														type='radio'
														id='both'
														checked={jobType === 'both'}
														value='both'
														onChange={() => {
															setJobType('both');
														}}
													/>
												</div>
											</Form.Group>
										</Row>
									</Form>

									<hr />
									{/* Previous Experience */}
									{userType === 'Member' ||
										(userType === 'member' && (
											<Form
												style={{
													border: '1px solid',
													marginTop: '12px',
													marginBottom: '10px',
												}}
											>
												<Row>
													<Col sm={12}>
														<div
															className={'top-actions bg-label'}
															style={{ borderBottom: ' 1px solid' }}
														>
															<h4
																className={
																	'heading text-orange fw-bold p-2 ms-2 rounded'
																}
															>
																Previous Experience & References
															</h4>
														</div>
													</Col>
												</Row>

												<div>
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.6%',
															marginLeft: '15px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
															{' '}
															Previous Experience{' '}
															{/* <span style={{ color: "red" }}>*</span>{" "} */}
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.6%',
															marginLeft: '15px',
														}}
													>
														<Col>
															<ul className='list-group list-group-flush'>
																{/* <li className="list-group-item font-weight-normal"></li> */}
																<li className='list-group-item fw-bold'>
																	{experiences.map((item, i) => {
																		return (
																			<div key={i}>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									Company
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								maxlength='80'
																								name='company'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										experiences,
																										setExperiences
																									)
																								}
																								type='text'
																								placeholder='Enter Organization'
																								defaultValue={item.company}
																								value={item.company}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={6}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									From
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								name='start_date'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										experiences,
																										setExperiences
																									)
																								}
																								type='date'
																								placeholder='Enter Start Date'
																								defaultValue={item.start_date}
																								value={item.start_date}
																							/>
																						</InputGroup>
																					</Col>
																					<Col md={6}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									To
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								name='end_date'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										experiences,
																										setExperiences
																									)
																								}
																								type='date'
																								placeholder='Enter End Date'
																								defaultValue={item.end_date}
																								value={item.end_date}
																								min={item.start_date}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				></Row>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									Description
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								as='textarea'
																								name='description'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										experiences,
																										setExperiences
																									)
																								}
																								type='text'
																								placeholder='Enter description'
																								rows='3'
																								defaultValue={item.description}
																								value={item.description}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>

																				<div className='btn-box'>
																					{/* <Button variant="outline-success">Success</Button> */}
																					{experiences.length !== 1 && (
																						<Button
																							variant='outline-danger'
																							style={{ marginRight: '48px' }}
																							onClick={() =>
																								handleRemove(
																									i,
																									experiences,
																									setExperiences
																								)
																							}
																						>
																							Remove this Experience
																						</Button>
																					)}
																					{experiences.length - 1 === i && (
																						<Button
																							variant='outline-success'
																							onClick={() =>
																								setExperiences([
																									...experiences,
																									{
																										start_date: '',
																										end_date: '',
																										company: '',
																										description: '',
																									},
																								])
																							}
																						>
																							Add an Experience
																						</Button>
																					)}
																				</div>
																			</div>
																		);
																	})}
																</li>{' '}
															</ul>
														</Col>
													</Row>
													{/*  */}
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.6%',
															marginLeft: '15px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
															{' '}
															References{' '}
															{/* <span style={{ color: "red" }}>*</span>{" "} */}
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.6%',
															marginLeft: '15px',
														}}
													>
														<Col>
															<ul className='list-group list-group-flush'>
																<li className='list-group-item fw-bold'>
																	{references.map((item, i) => {
																		return (
																			<div key={i}>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									First Name
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								maxlength='30'
																								name='first_name'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										references,
																										setReferences
																									)
																								}
																								type='text'
																								placeholder='Enter First Name'
																								defaultValue={item.first_name}
																								value={item.first_name}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									Last Name
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								maxlength='30'
																								name='last_name'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										references,
																										setReferences
																									)
																								}
																								type='text'
																								placeholder='Enter Last Name'
																								defaultValue={item.last_name}
																								value={item.last_name}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>

																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									Email
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								name='email'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										references,
																										setReferences
																									)
																								}
																								type='text'
																								placeholder='Enter Email Address'
																								defaultValue={item.email}
																								value={item.email}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>
																				<Row
																					style={{
																						marginTop: '15px',
																						marginBottom: '15px',
																					}}
																				>
																					<Col md={12}>
																						<InputGroup controlId='formBasicEmail'>
																							<>
																								<InputGroup.Text className='fw-bold'>
																									Type of Reference
																									{/* <span style={{ color: "red" }}>*</span> */}
																								</InputGroup.Text>
																							</>
																							<FormControl
																								maxlength='50'
																								name='type_of_reference'
																								onChange={e =>
																									handleInputChange(
																										e,
																										i,
																										references,
																										setReferences
																									)
																								}
																								type='text'
																								placeholder='Enter Type of Reference'
																								defaultValue={
																									item.type_of_reference
																								}
																								value={item.type_of_reference}
																							/>
																						</InputGroup>
																					</Col>
																				</Row>
																				<div className='btn-box'>
																					{/* <Button variant="outline-success">Success</Button> */}
																					{references.length !== 1 && (
																						<Button
																							variant='outline-danger'
																							style={{ marginRight: '48px' }}
																							onClick={() =>
																								handleRemove(
																									i,
																									references,
																									setReferences
																								)
																							}
																						>
																							Remove this Reference
																						</Button>
																					)}
																					{references.length - 1 === i && (
																						<Button
																							variant='outline-success'
																							onClick={() =>
																								setReferences([
																									...references,
																									{
																										first_name: '',
																										last_name: '',
																										email: '',
																										type_of_reference: '',
																									},
																								])
																							}
																						>
																							Add a Reference
																						</Button>
																					)}
																				</div>
																			</div>
																		);
																	})}
																</li>
															</ul>
														</Col>
													</Row>
													{/* Supporting file */}
													<Row
														className='bg-label mt-4'
														style={{
															width: '98.6%',
															marginLeft: '15px',
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															borderTop: ' 1px solid',
														}}
													>
														<Col sm={12} className='fw-bold p-1 ms-3 rounded'>
															{' '}
															Supporting Files{' '}
															{/* <span style={{ color: "red" }}>*</span>{" "} */}
														</Col>
													</Row>
													<Row
														style={{
															borderLeft: '1px solid',
															borderBottom: ' 1px solid',
															width: '98.6%',
															marginLeft: '15px',
															marginBottom: '15px',
														}}
													>
														<Col>
															<ul className='list-group list-group-flush'>
																<li className='list-group-item fw-bold'>
																	{/* Supporting Files: */}
																	<Form.Group
																		controlId='formFile'
																		for='myfile'
																		className='mb-3'
																	>
																		<Form.Control
																			accept='/pdf'
																			type='file'
																			name='supporting_file'
																			onChange={changeHandler}
																			placeholder='Upload File'
																			defaultValue={
																				allValues.supporting_file?.file?.name
																			}
																		/>
																		<h6>
																			<a
																				href={
																					allValues.supporting_file &&
																					allValues.supporting_file
																				}
																				target='_blank'
																				rel='noreferrer'
																			>
																				Preview
																			</a>
																		</h6>
																	</Form.Group>
																</li>
															</ul>
														</Col>
													</Row>
												</div>
											</Form>
										))}
								</>
							) : null}
						</Col>
					</Row>
					<div style={{ textAlign: 'center' }}>
						<button onClick={onClickHandler} className='btn-save-profile fw-bold' style={{fontFamily: "inherit"}}>
							Save Profile
						</button>
					</div>
				</div>
			)}
		</Container>
	);
}

export default ProfileUpdate;
